import Service from "../../Service";
import Vue from "vue";
const resource = "ResponsibleCollecting/";

export default {
  save(prd, requestID) {
    console.log('llega aqui');
    return Service.post(resource + "save", prd, {
      params: { requestID: requestID },
    });
  },

  pagination(parameters, requestID) {
    console.log('parametro',parameters)
    return Service.post(resource + "pagination", parameters, {
      params: { requestID: requestID },
    });
  },
};